import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.replace";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import SparkMD5 from 'spark-md5';

function request(_x, _x2, _x3) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(method, url, data) {
    var extra,
        _extra$headers,
        headers,
        onProgress,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            extra = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
            _extra$headers = extra.headers, headers = _extra$headers === void 0 ? {} : _extra$headers, onProgress = extra.onProgress;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              xhr.open(method, url);

              if (headers != null) {
                Object.keys(headers).forEach(function (key) {
                  return xhr.setRequestHeader(key, headers[key]);
                });
              }

              xhr.addEventListener('load', function (e) {
                var data = null;

                try {
                  var _e$target;

                  data = JSON.parse((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.responseText);
                } catch (err) {
                  data = e.target.responseText;
                }

                return resolve(data);
              });
              xhr.addEventListener('error', function (err) {
                return reject(err);
              });
              xhr.upload.addEventListener('progress', onProgress);

              if (headers['Content-Type'] === 'application/json') {
                xhr.send(JSON.stringify(data));
              } else {
                xhr.send(data);
              }
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _request.apply(this, arguments);
}

function sanitizeFilename(filename) {
  return filename.replace(/[^a-z0-9.]/gi, '_');
}

function _readAsArrayBuffer(file) {
  var reader = new FileReader();
  return new Promise(function (resolve) {
    reader.onload = function (e) {
      resolve(e.target.result);
    };

    reader.readAsArrayBuffer(file);
  });
}

function _getFileChecksum(_x4) {
  return _getFileChecksum2.apply(this, arguments);
}

function _getFileChecksum2() {
  _getFileChecksum2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(file) {
    var CHUNK_SIZE, md5, start, end, fileBuffer;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            CHUNK_SIZE = 2097152; // Read in chunks of 2MB

            md5 = new SparkMD5.ArrayBuffer();
            start = 0;

          case 3:
            if (!(start < file.size)) {
              _context2.next = 12;
              break;
            }

            end = start + CHUNK_SIZE >= file.size ? file.size : start + CHUNK_SIZE;
            _context2.next = 7;
            return _readAsArrayBuffer(file.slice(start, end));

          case 7:
            fileBuffer = _context2.sent;
            md5.append(fileBuffer);
            start = end;
            _context2.next = 3;
            break;

          case 12:
            return _context2.abrupt("return", md5.end(true));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getFileChecksum2.apply(this, arguments);
}

function _parseFile(_x5, _x6) {
  return _parseFile2.apply(this, arguments);
}

function _parseFile2() {
  _parseFile2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(file, sanitize) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = sanitize(file.name);
            _context3.t1 = file.size;
            _context3.t2 = btoa;
            _context3.next = 5;
            return _getFileChecksum(file);

          case 5:
            _context3.t3 = _context3.sent;
            _context3.t4 = (0, _context3.t2)(_context3.t3);
            _context3.t5 = file.type;
            return _context3.abrupt("return", {
              filename: _context3.t0,
              byte_size: _context3.t1,
              checksum: _context3.t4,
              content_type: _context3.t5
            });

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _parseFile2.apply(this, arguments);
}

function _signBlob(_x7, _x8) {
  return _signBlob2.apply(this, arguments);
}

function _signBlob2() {
  _signBlob2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(signingUrl, blob) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return request('POST', signingUrl, {
              blob: blob
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _signBlob2.apply(this, arguments);
}

function _directUpload(_x9, _x10, _x11) {
  return _directUpload2.apply(this, arguments);
}

function _directUpload2() {
  _directUpload2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(blobSignature, file, onProgress) {
    var _blobSignature$direct, url, headers;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _blobSignature$direct = blobSignature.direct_upload, url = _blobSignature$direct.url, headers = _blobSignature$direct.headers;
            _context5.next = 3;
            return request('PUT', url, file, {
              headers: headers,
              onProgress: onProgress
            });

          case 3:
            return _context5.abrupt("return", _context5.sent);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _directUpload2.apply(this, arguments);
}

function _uploadFile(_x12, _x13, _x14) {
  return _uploadFile2.apply(this, arguments);
}

function _uploadFile2() {
  _uploadFile2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(file, signingUrl, extra) {
    var sanitize, onProgress, blob, signingResult, result;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            sanitize = extra.sanitize, onProgress = extra.onProgress;
            _context6.next = 3;
            return _parseFile(file, sanitize);

          case 3:
            blob = _context6.sent;
            _context6.next = 6;
            return _signBlob(signingUrl, blob);

          case 6:
            signingResult = _context6.sent;
            _context6.next = 9;
            return _directUpload(signingResult, file, onProgress != null ? function (e) {
              return onProgress(file, e);
            } : function () {});

          case 9:
            result = _context6.sent;
            return _context6.abrupt("return", {
              blob: blob,
              signingResult: signingResult,
              result: result
            });

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _uploadFile2.apply(this, arguments);
}

export function uploadFile(_x15, _x16, _x17) {
  return _uploadFile3.apply(this, arguments);
}

function _uploadFile3() {
  _uploadFile3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(file, signingUrl, extra) {
    var onStart, _sanitize, onProgress, onError, onFinish, signingResult, uploadResult;

    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            onStart = extra.onStart, _sanitize = extra.sanitize, onProgress = extra.onProgress, onError = extra.onError, onFinish = extra.onFinish;

            if (onStart != null) {
              onStart(file);
            }

            _context7.prev = 2;
            _context7.next = 5;
            return _uploadFile(file, signingUrl, {
              sanitize: function sanitize(name) {
                return _sanitize ? sanitizeFilename(_sanitize(name)) : sanitizeFilename(name);
              },
              onProgress: onProgress
            });

          case 5:
            uploadResult = _context7.sent;
            signingResult = uploadResult.signingResult;
            _context7.next = 12;
            break;

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](2);

            if (onError != null) {
              onError(file, _context7.t0);
            }

          case 12:
            if (onFinish != null) {
              onFinish(file, signingResult);
            }

            return _context7.abrupt("return", {
              file: file,
              signingResult: signingResult
            });

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[2, 9]]);
  }));
  return _uploadFile3.apply(this, arguments);
}

export function uploadFiles(_x18, _x19, _x20) {
  return _uploadFiles.apply(this, arguments);
}

function _uploadFiles() {
  _uploadFiles = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee8(files, signingUrl, extra) {
    var onInit, onComplete, rest, promises, uploadedFiles;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            onInit = extra.onInit, onComplete = extra.onComplete, rest = _objectWithoutProperties(extra, ["onInit", "onComplete"]);

            if (onInit != null) {
              onInit(files);
            }

            promises = _toConsumableArray(files).map(function (file) {
              return uploadFile(file, signingUrl, rest);
            });
            _context8.next = 5;
            return Promise.all(promises);

          case 5:
            uploadedFiles = _context8.sent;

            if (onComplete != null) {
              onComplete(uploadedFiles);
            }

            return _context8.abrupt("return", uploadedFiles);

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _uploadFiles.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy91cGxvYWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLFFBQVAsTUFBcUIsV0FBckI7O1NBTWUsTzs7Ozs7OzswQkFBZixpQkFDRSxNQURGLEVBRUUsR0FGRixFQUdFLElBSEY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBSUUsWUFBQSxLQUpGLDJEQUkwRSxFQUoxRTtBQUFBLDZCQU11QyxLQU52QyxDQU1VLE9BTlYsRUFNVSxPQU5WLCtCQU1vQixFQU5wQixtQkFNd0IsVUFOeEIsR0FNdUMsS0FOdkMsQ0FNd0IsVUFOeEI7QUFBQSw2Q0FPUyxJQUFJLE9BQUosQ0FBWSxVQUFDLE9BQUQsRUFBVSxNQUFWLEVBQW9CO0FBQ3JDLGtCQUFNLEdBQUcsR0FBRyxJQUFJLGNBQUosRUFBWjtBQUNBLGNBQUEsR0FBRyxDQUFDLElBQUosQ0FBUyxNQUFULEVBQWlCLEdBQWpCOztBQUVBLGtCQUFJLE9BQU8sSUFBSSxJQUFmLEVBQXFCO0FBQ25CLGdCQUFBLE1BQU0sQ0FBQyxJQUFQLENBQVksT0FBWixFQUFxQixPQUFyQixDQUE2QixVQUFDLEdBQUQ7QUFBQSx5QkFBUyxHQUFHLENBQUMsZ0JBQUosQ0FBcUIsR0FBckIsRUFBMEIsT0FBTyxDQUFDLEdBQUQsQ0FBakMsQ0FBVDtBQUFBLGlCQUE3QjtBQUNEOztBQUVELGNBQUEsR0FBRyxDQUFDLGdCQUFKLENBQXFCLE1BQXJCLEVBQTZCLFVBQUMsQ0FBRCxFQUEwQjtBQUNyRCxvQkFBSSxJQUFJLEdBQUcsSUFBWDs7QUFDQSxvQkFBSTtBQUFBOztBQUNGLGtCQUFBLElBQUksR0FBRyxJQUFJLENBQUMsS0FBTCxjQUFXLENBQUMsQ0FBQyxNQUFiLDhDQUFXLFVBQVUsWUFBckIsQ0FBUDtBQUNELGlCQUZELENBRUUsT0FBTyxHQUFQLEVBQVk7QUFDWixrQkFBQSxJQUFJLEdBQUcsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxZQUFoQjtBQUNEOztBQUNELHVCQUFPLE9BQU8sQ0FBQyxJQUFELENBQWQ7QUFDRCxlQVJEO0FBU0EsY0FBQSxHQUFHLENBQUMsZ0JBQUosQ0FBcUIsT0FBckIsRUFBOEIsVUFBQyxHQUFEO0FBQUEsdUJBQVMsTUFBTSxDQUFDLEdBQUQsQ0FBZjtBQUFBLGVBQTlCO0FBQ0EsY0FBQSxHQUFHLENBQUMsTUFBSixDQUFXLGdCQUFYLENBQTRCLFVBQTVCLEVBQXdDLFVBQXhDOztBQUVBLGtCQUFJLE9BQU8sQ0FBQyxjQUFELENBQVAsS0FBNEIsa0JBQWhDLEVBQW9EO0FBQ2xELGdCQUFBLEdBQUcsQ0FBQyxJQUFKLENBQVMsSUFBSSxDQUFDLFNBQUwsQ0FBZSxJQUFmLENBQVQ7QUFDRCxlQUZELE1BRU87QUFDTCxnQkFBQSxHQUFHLENBQUMsSUFBSixDQUFTLElBQVQ7QUFDRDtBQUNGLGFBekJNLENBUFQ7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsRzs7OztBQW1DQSxTQUFTLGdCQUFULENBQTBCLFFBQTFCLEVBQTBDO0FBQ3hDLFNBQU8sUUFBUSxDQUFDLE9BQVQsQ0FBaUIsY0FBakIsRUFBaUMsR0FBakMsQ0FBUDtBQUNEOztBQUVELFNBQVMsa0JBQVQsQ0FBNEIsSUFBNUIsRUFBc0M7QUFDcEMsTUFBTSxNQUFNLEdBQUcsSUFBSSxVQUFKLEVBQWY7QUFDQSxTQUFPLElBQUksT0FBSixDQUFZLFVBQUMsT0FBRCxFQUFZO0FBQzdCLElBQUEsTUFBTSxDQUFDLE1BQVAsR0FBZ0IsVUFBQyxDQUFELEVBQTBCO0FBQ3hDLE1BQUEsT0FBTyxDQUFDLENBQUMsQ0FBQyxNQUFGLENBQVMsTUFBVixDQUFQO0FBQ0QsS0FGRDs7QUFHQSxJQUFBLE1BQU0sQ0FBQyxpQkFBUCxDQUF5QixJQUF6QjtBQUNELEdBTE0sQ0FBUDtBQU1EOztTQUVjLGdCOzs7Ozs7OzBCQUFmLGtCQUFnQyxJQUFoQztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFDUSxZQUFBLFVBRFIsR0FDcUIsT0FEckIsRUFDOEI7O0FBQ3RCLFlBQUEsR0FGUixHQUVjLElBQUksUUFBUSxDQUFDLFdBQWIsRUFGZDtBQUlNLFlBQUEsS0FKTixHQUljLENBSmQ7O0FBQUE7QUFBQSxrQkFLUyxLQUFLLEdBQUcsSUFBSSxDQUFDLElBTHRCO0FBQUE7QUFBQTtBQUFBOztBQU1VLFlBQUEsR0FOVixHQU1nQixLQUFLLEdBQUcsVUFBUixJQUFzQixJQUFJLENBQUMsSUFBM0IsR0FBa0MsSUFBSSxDQUFDLElBQXZDLEdBQThDLEtBQUssR0FBRyxVQU50RTtBQUFBO0FBQUEsbUJBTzZCLGtCQUFrQixDQUFDLElBQUksQ0FBQyxLQUFMLENBQVcsS0FBWCxFQUFrQixHQUFsQixDQUFELENBUC9DOztBQUFBO0FBT1UsWUFBQSxVQVBWO0FBUUksWUFBQSxHQUFHLENBQUMsTUFBSixDQUFXLFVBQVg7QUFDQSxZQUFBLEtBQUssR0FBRyxHQUFSO0FBVEo7QUFBQTs7QUFBQTtBQUFBLDhDQVlTLEdBQUcsQ0FBQyxHQUFKLENBQVEsSUFBUixDQVpUOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLEc7Ozs7U0FzQmUsVTs7Ozs7OzswQkFBZixrQkFBMEIsSUFBMUIsRUFBc0MsUUFBdEM7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQUVjLFFBQVEsQ0FBQyxJQUFJLENBQUMsSUFBTixDQUZ0QjtBQUFBLDJCQUdlLElBQUksQ0FBQyxJQUhwQjtBQUFBLDJCQUljLElBSmQ7QUFBQTtBQUFBLG1CQUl5QixnQkFBZ0IsQ0FBQyxJQUFELENBSnpDOztBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQUtrQixJQUFJLENBQUMsSUFMdkI7QUFBQTtBQUVJLGNBQUEsUUFGSjtBQUdJLGNBQUEsU0FISjtBQUlJLGNBQUEsUUFKSjtBQUtJLGNBQUEsWUFMSjtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLEc7Ozs7U0FpQmUsUzs7Ozs7OzswQkFBZixrQkFBeUIsVUFBekIsRUFBNkMsSUFBN0M7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsbUJBQ2dCLE9BQU8sQ0FDbkIsTUFEbUIsRUFFbkIsVUFGbUIsRUFHbkI7QUFBRSxjQUFBLElBQUksRUFBSjtBQUFGLGFBSG1CLEVBSW5CO0FBQ0UsY0FBQSxPQUFPLEVBQUU7QUFDUCxnQ0FBZ0I7QUFEVDtBQURYLGFBSm1CLENBRHZCOztBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsRzs7OztTQWFlLGE7Ozs7Ozs7MEJBQWYsa0JBQ0UsYUFERixFQUVFLElBRkYsRUFHRSxVQUhGO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxvQ0FLMkIsYUFBYSxDQUFDLGFBTHpDLEVBS1UsR0FMVix5QkFLVSxHQUxWLEVBS2UsT0FMZix5QkFLZSxPQUxmO0FBQUE7QUFBQSxtQkFNZSxPQUFPLENBQUMsS0FBRCxFQUFRLEdBQVIsRUFBYSxJQUFiLEVBQW1CO0FBQ3JDLGNBQUEsT0FBTyxFQUFQLE9BRHFDO0FBRXJDLGNBQUEsVUFBVSxFQUFWO0FBRnFDLGFBQW5CLENBTnRCOztBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsRzs7OztTQVllLFc7Ozs7Ozs7MEJBQWYsa0JBQ0UsSUFERixFQUVFLFVBRkYsRUFHRSxLQUhGO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQVFVLFlBQUEsUUFSVixHQVFtQyxLQVJuQyxDQVFVLFFBUlYsRUFRb0IsVUFScEIsR0FRbUMsS0FSbkMsQ0FRb0IsVUFScEI7QUFBQTtBQUFBLG1CQVNxQixVQUFVLENBQUMsSUFBRCxFQUFPLFFBQVAsQ0FUL0I7O0FBQUE7QUFTUSxZQUFBLElBVFI7QUFBQTtBQUFBLG1CQVU4QixTQUFTLENBQUMsVUFBRCxFQUFhLElBQWIsQ0FWdkM7O0FBQUE7QUFVUSxZQUFBLGFBVlI7QUFBQTtBQUFBLG1CQVd1QixhQUFhLENBQ2hDLGFBRGdDLEVBRWhDLElBRmdDLEVBR2hDLFVBQVUsSUFBSSxJQUFkLEdBQXFCLFVBQUMsQ0FBRDtBQUFBLHFCQUFPLFVBQVUsQ0FBQyxJQUFELEVBQU8sQ0FBUCxDQUFqQjtBQUFBLGFBQXJCLEdBQWtELFlBQUssQ0FBRyxDQUgxQixDQVhwQzs7QUFBQTtBQVdRLFlBQUEsTUFYUjtBQUFBLDhDQWdCUztBQUFFLGNBQUEsSUFBSSxFQUFKLElBQUY7QUFBUSxjQUFBLGFBQWEsRUFBYixhQUFSO0FBQXVCLGNBQUEsTUFBTSxFQUFOO0FBQXZCLGFBaEJUOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLEc7Ozs7QUF3QkEsZ0JBQXNCLFVBQXRCO0FBQUE7QUFBQTs7Ozs7MEJBQU8sa0JBQ0wsSUFESyxFQUVMLFVBRkssRUFHTCxLQUhLO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFXRyxZQUFBLE9BWEgsR0FXd0QsS0FYeEQsQ0FXRyxPQVhILEVBV1ksU0FYWixHQVd3RCxLQVh4RCxDQVdZLFFBWFosRUFXc0IsVUFYdEIsR0FXd0QsS0FYeEQsQ0FXc0IsVUFYdEIsRUFXa0MsT0FYbEMsR0FXd0QsS0FYeEQsQ0FXa0MsT0FYbEMsRUFXMkMsUUFYM0MsR0FXd0QsS0FYeEQsQ0FXMkMsUUFYM0M7O0FBYUwsZ0JBQUksT0FBTyxJQUFJLElBQWYsRUFBcUI7QUFDbkIsY0FBQSxPQUFPLENBQUMsSUFBRCxDQUFQO0FBQ0Q7O0FBZkk7QUFBQTtBQUFBLG1CQW9Cd0IsV0FBVyxDQUFDLElBQUQsRUFBTyxVQUFQLEVBQW1CO0FBQ3ZELGNBQUEsUUFBUSxFQUFFLGtCQUFDLElBQUQ7QUFBQSx1QkFBVyxTQUFRLEdBQUcsZ0JBQWdCLENBQUMsU0FBUSxDQUFDLElBQUQsQ0FBVCxDQUFuQixHQUFzQyxnQkFBZ0IsQ0FBQyxJQUFELENBQXpFO0FBQUEsZUFENkM7QUFFdkQsY0FBQSxVQUFVLEVBQVY7QUFGdUQsYUFBbkIsQ0FwQm5DOztBQUFBO0FBb0JHLFlBQUEsWUFwQkg7QUF3QkgsWUFBQSxhQUFhLEdBQUcsWUFBWSxDQUFDLGFBQTdCO0FBeEJHO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQTBCSCxnQkFBSSxPQUFPLElBQUksSUFBZixFQUFxQjtBQUNuQixjQUFBLE9BQU8sQ0FBQyxJQUFELGVBQVA7QUFDRDs7QUE1QkU7QUErQkwsZ0JBQUksUUFBUSxJQUFJLElBQWhCLEVBQXNCO0FBQ3BCLGNBQUEsUUFBUSxDQUFDLElBQUQsRUFBTyxhQUFQLENBQVI7QUFDRDs7QUFqQ0ksOENBbUNFO0FBQUUsY0FBQSxJQUFJLEVBQUosSUFBRjtBQUFRLGNBQUEsYUFBYSxFQUFiO0FBQVIsYUFuQ0Y7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsRzs7OztBQXNDUCxnQkFBc0IsV0FBdEI7QUFBQTtBQUFBOzs7OzswQkFBTyxrQkFDTCxLQURLLEVBRUwsVUFGSyxFQUdMLEtBSEs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBMEJHLFlBQUEsTUExQkgsR0EwQm1DLEtBMUJuQyxDQTBCRyxNQTFCSCxFQTBCVyxVQTFCWCxHQTBCbUMsS0ExQm5DLENBMEJXLFVBMUJYLEVBMEIwQixJQTFCMUIsNEJBMEJtQyxLQTFCbkM7O0FBNEJMLGdCQUFJLE1BQU0sSUFBSSxJQUFkLEVBQW9CO0FBQ2xCLGNBQUEsTUFBTSxDQUFDLEtBQUQsQ0FBTjtBQUNEOztBQUVLLFlBQUEsUUFoQ0QsR0FnQ1ksbUJBQUksS0FBSixFQUFXLEdBQVgsQ0FBZSxVQUFDLElBQUQ7QUFBQSxxQkFBVSxVQUFVLENBQUMsSUFBRCxFQUFPLFVBQVAsRUFBbUIsSUFBbkIsQ0FBcEI7QUFBQSxhQUFmLENBaENaO0FBQUE7QUFBQSxtQkFpQzRDLE9BQU8sQ0FBQyxHQUFSLENBQVksUUFBWixDQWpDNUM7O0FBQUE7QUFpQ0MsWUFBQSxhQWpDRDs7QUFtQ0wsZ0JBQUksVUFBVSxJQUFJLElBQWxCLEVBQXdCO0FBQ3RCLGNBQUEsVUFBVSxDQUFDLGFBQUQsQ0FBVjtBQUNEOztBQXJDSSw4Q0F1Q0UsYUF2Q0Y7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsRyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBTcGFya01ENSBmcm9tICdzcGFyay1tZDUnO1xuXG5pbnRlcmZhY2UgSGVhZGVycyB7XG4gIFtrZXk6IHN0cmluZ106IHN0cmluZztcbn1cblxuYXN5bmMgZnVuY3Rpb24gcmVxdWVzdChcbiAgbWV0aG9kOiBzdHJpbmcsXG4gIHVybDogc3RyaW5nLFxuICBkYXRhOiBhbnksXG4gIGV4dHJhOiB7IG9uUHJvZ3Jlc3M/OiAoZTogUHJvZ3Jlc3NFdmVudCkgPT4gdm9pZDsgaGVhZGVycz86IEhlYWRlcnMgfSA9IHt9LFxuKSB7XG4gIGNvbnN0IHsgaGVhZGVycyA9IHt9LCBvblByb2dyZXNzIH0gPSBleHRyYTtcbiAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICBjb25zdCB4aHIgPSBuZXcgWE1MSHR0cFJlcXVlc3QoKTtcbiAgICB4aHIub3BlbihtZXRob2QsIHVybCk7XG5cbiAgICBpZiAoaGVhZGVycyAhPSBudWxsKSB7XG4gICAgICBPYmplY3Qua2V5cyhoZWFkZXJzKS5mb3JFYWNoKChrZXkpID0+IHhoci5zZXRSZXF1ZXN0SGVhZGVyKGtleSwgaGVhZGVyc1trZXldKSk7XG4gICAgfVxuXG4gICAgeGhyLmFkZEV2ZW50TGlzdGVuZXIoJ2xvYWQnLCAoZTogUHJvZ3Jlc3NFdmVudDxhbnk+KSA9PiB7XG4gICAgICBsZXQgZGF0YSA9IG51bGw7XG4gICAgICB0cnkge1xuICAgICAgICBkYXRhID0gSlNPTi5wYXJzZShlLnRhcmdldD8ucmVzcG9uc2VUZXh0KTtcbiAgICAgIH0gY2F0Y2ggKGVycikge1xuICAgICAgICBkYXRhID0gZS50YXJnZXQucmVzcG9uc2VUZXh0O1xuICAgICAgfVxuICAgICAgcmV0dXJuIHJlc29sdmUoZGF0YSk7XG4gICAgfSk7XG4gICAgeGhyLmFkZEV2ZW50TGlzdGVuZXIoJ2Vycm9yJywgKGVycikgPT4gcmVqZWN0KGVycikpO1xuICAgIHhoci51cGxvYWQuYWRkRXZlbnRMaXN0ZW5lcigncHJvZ3Jlc3MnLCBvblByb2dyZXNzIGFzIGFueSk7XG5cbiAgICBpZiAoaGVhZGVyc1snQ29udGVudC1UeXBlJ10gPT09ICdhcHBsaWNhdGlvbi9qc29uJykge1xuICAgICAgeGhyLnNlbmQoSlNPTi5zdHJpbmdpZnkoZGF0YSkpO1xuICAgIH0gZWxzZSB7XG4gICAgICB4aHIuc2VuZChkYXRhKTtcbiAgICB9XG4gIH0pO1xufVxuXG5mdW5jdGlvbiBzYW5pdGl6ZUZpbGVuYW1lKGZpbGVuYW1lOiBzdHJpbmcpIHtcbiAgcmV0dXJuIGZpbGVuYW1lLnJlcGxhY2UoL1teYS16MC05Ll0vZ2ksICdfJyk7XG59XG5cbmZ1bmN0aW9uIF9yZWFkQXNBcnJheUJ1ZmZlcihmaWxlOiBCbG9iKTogUHJvbWlzZTxCdWZmZXI+IHtcbiAgY29uc3QgcmVhZGVyID0gbmV3IEZpbGVSZWFkZXIoKTtcbiAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlKSA9PiB7XG4gICAgcmVhZGVyLm9ubG9hZCA9IChlOiBQcm9ncmVzc0V2ZW50PGFueT4pID0+IHtcbiAgICAgIHJlc29sdmUoZS50YXJnZXQucmVzdWx0KTtcbiAgICB9O1xuICAgIHJlYWRlci5yZWFkQXNBcnJheUJ1ZmZlcihmaWxlKTtcbiAgfSk7XG59XG5cbmFzeW5jIGZ1bmN0aW9uIF9nZXRGaWxlQ2hlY2tzdW0oZmlsZTogRmlsZSkge1xuICBjb25zdCBDSFVOS19TSVpFID0gMjA5NzE1MjsgLy8gUmVhZCBpbiBjaHVua3Mgb2YgMk1CXG4gIGNvbnN0IG1kNSA9IG5ldyBTcGFya01ENS5BcnJheUJ1ZmZlcigpO1xuXG4gIGxldCBzdGFydCA9IDA7XG4gIHdoaWxlIChzdGFydCA8IGZpbGUuc2l6ZSkge1xuICAgIGNvbnN0IGVuZCA9IHN0YXJ0ICsgQ0hVTktfU0laRSA+PSBmaWxlLnNpemUgPyBmaWxlLnNpemUgOiBzdGFydCArIENIVU5LX1NJWkU7XG4gICAgY29uc3QgZmlsZUJ1ZmZlciA9IGF3YWl0IF9yZWFkQXNBcnJheUJ1ZmZlcihmaWxlLnNsaWNlKHN0YXJ0LCBlbmQpKTtcbiAgICBtZDUuYXBwZW5kKGZpbGVCdWZmZXIpO1xuICAgIHN0YXJ0ID0gZW5kO1xuICB9XG5cbiAgcmV0dXJuIG1kNS5lbmQodHJ1ZSk7XG59XG5cbmludGVyZmFjZSBBbWF6b25CbG9iIHtcbiAgZmlsZW5hbWU6IHN0cmluZztcbiAgYnl0ZV9zaXplOiBudW1iZXI7XG4gIGNoZWNrc3VtOiBzdHJpbmc7XG4gIGNvbnRlbnRfdHlwZTogc3RyaW5nO1xufVxuXG5hc3luYyBmdW5jdGlvbiBfcGFyc2VGaWxlKGZpbGU6IEZpbGUsIHNhbml0aXplOiAoZmlsZW5hbWU6IHN0cmluZykgPT4gc3RyaW5nKTogUHJvbWlzZTxBbWF6b25CbG9iPiB7XG4gIHJldHVybiB7XG4gICAgZmlsZW5hbWU6IHNhbml0aXplKGZpbGUubmFtZSksXG4gICAgYnl0ZV9zaXplOiBmaWxlLnNpemUsXG4gICAgY2hlY2tzdW06IGJ0b2EoYXdhaXQgX2dldEZpbGVDaGVja3N1bShmaWxlKSksXG4gICAgY29udGVudF90eXBlOiBmaWxlLnR5cGUsXG4gIH07XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgU2lnbmluZ1Jlc3VsdCB7XG4gIGRpcmVjdF91cGxvYWQ6IHsgdXJsOiBzdHJpbmc7IGhlYWRlcnM6IEhlYWRlcnMgfTtcbiAgc2lnbmVkX2lkOiBzdHJpbmc7XG4gIGZpbGVuYW1lOiBzdHJpbmc7XG4gIGNvbnRlbnRfdHlwZTogc3RyaW5nO1xuICBpZDogc3RyaW5nO1xufVxuXG5hc3luYyBmdW5jdGlvbiBfc2lnbkJsb2Ioc2lnbmluZ1VybDogc3RyaW5nLCBibG9iOiBBbWF6b25CbG9iKTogUHJvbWlzZTxTaWduaW5nUmVzdWx0PiB7XG4gIHJldHVybiAoYXdhaXQgcmVxdWVzdChcbiAgICAnUE9TVCcsXG4gICAgc2lnbmluZ1VybCxcbiAgICB7IGJsb2IgfSxcbiAgICB7XG4gICAgICBoZWFkZXJzOiB7XG4gICAgICAgICdDb250ZW50LVR5cGUnOiAnYXBwbGljYXRpb24vanNvbicsXG4gICAgICB9LFxuICAgIH0sXG4gICkpIGFzIFByb21pc2U8U2lnbmluZ1Jlc3VsdD47XG59XG5cbmFzeW5jIGZ1bmN0aW9uIF9kaXJlY3RVcGxvYWQoXG4gIGJsb2JTaWduYXR1cmU6IFNpZ25pbmdSZXN1bHQsXG4gIGZpbGU6IEZpbGUsXG4gIG9uUHJvZ3Jlc3M/OiAoZTogUHJvZ3Jlc3NFdmVudCkgPT4gdm9pZCxcbikge1xuICBjb25zdCB7IHVybCwgaGVhZGVycyB9ID0gYmxvYlNpZ25hdHVyZS5kaXJlY3RfdXBsb2FkO1xuICByZXR1cm4gYXdhaXQgcmVxdWVzdCgnUFVUJywgdXJsLCBmaWxlLCB7XG4gICAgaGVhZGVycyxcbiAgICBvblByb2dyZXNzLFxuICB9KTtcbn1cblxuYXN5bmMgZnVuY3Rpb24gX3VwbG9hZEZpbGUoXG4gIGZpbGU6IEZpbGUsXG4gIHNpZ25pbmdVcmw6IHN0cmluZyxcbiAgZXh0cmE6IHtcbiAgICBzYW5pdGl6ZTogKGZpbGVuYW1lOiBzdHJpbmcpID0+IHN0cmluZztcbiAgICBvblByb2dyZXNzPzogKGZpbGU6IEZpbGUsIGU6IFByb2dyZXNzRXZlbnQpID0+IHZvaWQ7XG4gIH0sXG4pIHtcbiAgY29uc3QgeyBzYW5pdGl6ZSwgb25Qcm9ncmVzcyB9ID0gZXh0cmE7XG4gIGNvbnN0IGJsb2IgPSBhd2FpdCBfcGFyc2VGaWxlKGZpbGUsIHNhbml0aXplKTtcbiAgY29uc3Qgc2lnbmluZ1Jlc3VsdCA9IGF3YWl0IF9zaWduQmxvYihzaWduaW5nVXJsLCBibG9iKTtcbiAgY29uc3QgcmVzdWx0ID0gYXdhaXQgX2RpcmVjdFVwbG9hZChcbiAgICBzaWduaW5nUmVzdWx0LFxuICAgIGZpbGUsXG4gICAgb25Qcm9ncmVzcyAhPSBudWxsID8gKGUpID0+IG9uUHJvZ3Jlc3MoZmlsZSwgZSkgOiAoKSA9PiB7fSxcbiAgKTtcbiAgcmV0dXJuIHsgYmxvYiwgc2lnbmluZ1Jlc3VsdCwgcmVzdWx0IH07XG59XG5cbmludGVyZmFjZSBVcGxvYWRlZEZpbGUge1xuICBmaWxlOiBGaWxlO1xuICBzaWduaW5nUmVzdWx0PzogU2lnbmluZ1Jlc3VsdDtcbn1cblxuZXhwb3J0IGFzeW5jIGZ1bmN0aW9uIHVwbG9hZEZpbGUoXG4gIGZpbGU6IEZpbGUsXG4gIHNpZ25pbmdVcmw6IHN0cmluZyxcbiAgZXh0cmE6IHtcbiAgICBvblN0YXJ0PzogKGZpbGU6IEZpbGUpID0+IHZvaWQ7XG4gICAgb25Qcm9ncmVzcz86IChmaWxlOiBGaWxlLCBlOiBQcm9ncmVzc0V2ZW50KSA9PiB2b2lkO1xuICAgIG9uRmluaXNoPzogKGZpbGU6IEZpbGUsIHNpZ25pbmdSZXN1bHQ/OiBTaWduaW5nUmVzdWx0LCByZXN1bHQ/OiBhbnkpID0+IHZvaWQ7XG4gICAgb25FcnJvcj86IChmaWxlOiBGaWxlLCBlcnJvcjogRXJyb3IpID0+IHZvaWQ7XG4gICAgc2FuaXRpemU/OiAoZmlsZW5hbWU6IHN0cmluZykgPT4gc3RyaW5nO1xuICB9LFxuKTogUHJvbWlzZTxVcGxvYWRlZEZpbGU+IHtcbiAgY29uc3QgeyBvblN0YXJ0LCBzYW5pdGl6ZSwgb25Qcm9ncmVzcywgb25FcnJvciwgb25GaW5pc2ggfSA9IGV4dHJhO1xuXG4gIGlmIChvblN0YXJ0ICE9IG51bGwpIHtcbiAgICBvblN0YXJ0KGZpbGUpO1xuICB9XG5cbiAgbGV0IHNpZ25pbmdSZXN1bHQ7XG5cbiAgdHJ5IHtcbiAgICBjb25zdCB1cGxvYWRSZXN1bHQgPSBhd2FpdCBfdXBsb2FkRmlsZShmaWxlLCBzaWduaW5nVXJsLCB7XG4gICAgICBzYW5pdGl6ZTogKG5hbWUpID0+IChzYW5pdGl6ZSA/IHNhbml0aXplRmlsZW5hbWUoc2FuaXRpemUobmFtZSkpIDogc2FuaXRpemVGaWxlbmFtZShuYW1lKSksXG4gICAgICBvblByb2dyZXNzLFxuICAgIH0pO1xuICAgIHNpZ25pbmdSZXN1bHQgPSB1cGxvYWRSZXN1bHQuc2lnbmluZ1Jlc3VsdDtcbiAgfSBjYXRjaCAoZXJyKSB7XG4gICAgaWYgKG9uRXJyb3IgIT0gbnVsbCkge1xuICAgICAgb25FcnJvcihmaWxlLCBlcnIpO1xuICAgIH1cbiAgfVxuXG4gIGlmIChvbkZpbmlzaCAhPSBudWxsKSB7XG4gICAgb25GaW5pc2goZmlsZSwgc2lnbmluZ1Jlc3VsdCk7XG4gIH1cblxuICByZXR1cm4geyBmaWxlLCBzaWduaW5nUmVzdWx0IH07XG59XG5cbmV4cG9ydCBhc3luYyBmdW5jdGlvbiB1cGxvYWRGaWxlcyhcbiAgZmlsZXM6IEZpbGVMaXN0LFxuICBzaWduaW5nVXJsOiBzdHJpbmcsXG4gIGV4dHJhOiB7XG4gICAgLyoqIEZ1bmN0aW9uIGNhbGxlZCBiZWZvcmUgdGhlIHVwbG9hZCBzdGFydHMgKi9cbiAgICBvbkluaXQ/OiAoZmlsZXM6IEZpbGVMaXN0KSA9PiB2b2lkO1xuXG4gICAgLyoqIEZ1bmN0aW9uIGNhbGxlZCBiZWZvcmUgdGhlIHN0YXJ0IG9mIGVhY2ggZmlsZSB1cGxvYWQgKi9cbiAgICBvblN0YXJ0PzogKGZpbGU6IEZpbGUpID0+IHZvaWQ7XG5cbiAgICAvKiogRnVuY3Rpb24gY2FsbGVkIGR1cmluZyB0aGUgdXBsb2FkIGZvciBlYWNoIGZpbGUgKi9cbiAgICBvblByb2dyZXNzPzogKGZpbGU6IEZpbGUsIGU6IFByb2dyZXNzRXZlbnQpID0+IHZvaWQ7XG5cbiAgICAvKiogRnVuY3Rpb24gY2FsbGVkIGF0IHRoZSBlbmQgb2YgZWFjaCBmaWxlIHVwbG9hZCAqL1xuICAgIG9uRmluaXNoPzogKGZpbGU6IEZpbGUsIHNpZ25pbmdSZXN1bHQ/OiBTaWduaW5nUmVzdWx0LCByZXN1bHQ/OiBhbnkpID0+IHZvaWQ7XG5cbiAgICAvKiogRnVuY3Rpb24gY2FsbGVkIGNhbGxlZCBpZiBhbiBlcnJvciBpcyB0aHJvd24gZHVyaW5nIGVhY2ggZmlsZSB1cGxvYWQgKi9cbiAgICBvbkVycm9yPzogKGZpbGU6IEZpbGUsIGVycm9yOiBFcnJvcikgPT4gdm9pZDtcblxuICAgIC8qKiBGdW5jdGlvbiBjYWxsZWQgb25jZSBhbGwgZmlsZXMgaGF2ZSBiZWVuIHVwbG9hZGVkICovXG4gICAgb25Db21wbGV0ZT86IChmaWxlczogQXJyYXk8VXBsb2FkZWRGaWxlPikgPT4gdm9pZDtcblxuICAgIC8qKiBDdXN0b20gZnVuY3Rpb24gdG8gbW9kaWZ5IHRoZSBmaWxlIG5hbWUgYmVmb3JlIHVwbG9hZCwgbm90ZSB0aGF0IGEgZGVmYXVsdCBzYW5pdGl6ZXIgYWxyZWFkeSByZW1vdmVzIHdoaXRlc3BhY2UgKi9cbiAgICBzYW5pdGl6ZT86IChmaWxlbmFtZTogc3RyaW5nKSA9PiBzdHJpbmc7XG4gIH0sXG4pIHtcbiAgY29uc3QgeyBvbkluaXQsIG9uQ29tcGxldGUsIC4uLnJlc3QgfSA9IGV4dHJhO1xuXG4gIGlmIChvbkluaXQgIT0gbnVsbCkge1xuICAgIG9uSW5pdChmaWxlcyk7XG4gIH1cblxuICBjb25zdCBwcm9taXNlcyA9IFsuLi5maWxlc10ubWFwKChmaWxlKSA9PiB1cGxvYWRGaWxlKGZpbGUsIHNpZ25pbmdVcmwsIHJlc3QpKTtcbiAgY29uc3QgdXBsb2FkZWRGaWxlczogQXJyYXk8VXBsb2FkZWRGaWxlPiA9IGF3YWl0IFByb21pc2UuYWxsKHByb21pc2VzKTtcblxuICBpZiAob25Db21wbGV0ZSAhPSBudWxsKSB7XG4gICAgb25Db21wbGV0ZSh1cGxvYWRlZEZpbGVzKTtcbiAgfVxuXG4gIHJldHVybiB1cGxvYWRlZEZpbGVzO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ==